import TagManager from "react-gtm-module";

export default TagManager;
